import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Message } from '@app/_components/message';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class MessageService
{
	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'messages';

	add(message: Message): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(message));
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`, message);
	}

	update(message: Message): Observable<ApiResponse>
	{
		return this.http.patch<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`, message);
	}

	delete(messageId: number): Observable<ApiResponse>
	{
		return this.http.delete<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/${ messageId }`);
	}

	findAll(): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse>
	{

		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findById(id: number): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/${ id }`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }/${ id }/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any)
	{
		try
		{
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta)
			{
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++)
				{
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters)
			{
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++)
				{
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error)
		{
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
